import { call, put, select } from 'redux-saga/effects';
import { setDomainUsageSnapshot } from '../../../../state/analytic/analyticAdminSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchDomainUsageSnapshotSaga() {
    const { domain } = yield select(selectUserCredentials);
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `usage/domains/${encodeURIComponent(domain)}`
        );
        yield put(setDomainUsageSnapshot(data));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch domain usage snaphsot', err?.response?.status, err?.message);
    }
}